var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('HelloWidgetTemplate',_vm._b({},'HelloWidgetTemplate',_vm.computedProps,false),[_c('div',{staticClass:"content"},[_c('ion-icon',{staticClass:"content__icon",attrs:{"name":_vm.icons.alert}}),_c('h2',[_vm._v(_vm._s(_vm.text))])],1),_c('p',[_vm._v(_vm._s(_vm.subtext))])])
}
var staticRenderFns = []

export { render, staticRenderFns }